import React from "react";
import { fire } from "../../firebase/index";
import TimeStamp from "react-timestamp";
import { Slider, Handles, Tracks, Rail } from "react-compound-slider";

function Handle({ handle: { id, value, percent }, getHandleProps }) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: "absolute",
        marginLeft: -15,
        marginTop: 25,
        zIndex: 2,
        width: 40,
        height: 40,
        border: 0,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: "50%",
        backgroundColor: "#2C4870",
        color: "#333",
      }}
      {...getHandleProps(id)}
    >
      <div style={{ fontFamily: "Roboto", fontSize: 11, marginTop: -35 }}>
        <TimeStamp time={value / 1000} format="date" />
      </div>
    </div>
  );
}
function Track({ source, target, getTrackProps }) {
  return (
    <div
      style={{
        position: "absolute",
        height: 10,
        zIndex: 1,
        marginTop: 35,
        backgroundColor: "#546C91",
        borderRadius: 5,
        cursor: "pointer",
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {
        ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
      }
    />
  );
}

// function Tick({ tick, count }) {
//     return (
//         <div>
//             <div
//                 style={{
//                     position: 'absolute',
//                     marginTop: 52,
//                     marginLeft: -0.5,
//                     width: 1,
//                     height: 8,
//                     backgroundColor: 'silver',
//                     left: `${tick.percent}%`,
//                 }}
//             />
//             <div
//                 style={{
//                     position: 'absolute',
//                     marginTop: 60,
//                     fontSize: 10,
//                     textAlign: 'center',
//                     marginLeft: `${-(100 / count) / 2}%`,
//                     width: `${100 / count}%`,
//                     left: `${tick.percent}%`,
//                 }}
//             >
//                 {tick.value}
//             </div>
//         </div>
//     )
// }

export default function MapSlider(props) {
  const minVal = props.minVal;
  const maxVal = props.maxVal;

  const snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  const fetchSelectedLockFromAuditLocksListFiltered = (min, max) => {
    fire
      .database()
      .ref("AuditTrail")
      .child(props.selectedLock)
      .orderByChild("time")
      .startAt(min)
      .endAt(max)
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = snapshotToArray(snapshot);
        // console.log(tempArray)
        tempArray.reverse();
        props.setArray(tempArray);
      });
  };

  return (
    <Slider
      className="sliderStyle"
      domain={[minVal, maxVal]}
      step={1}
      mode={2}
      values={[minVal, maxVal]}
      onChange={(event) => {
        let min = event[0];
        let max = event[1];
        // console.log(min);
        // console.log(max);
        fetchSelectedLockFromAuditLocksListFiltered(min, max);
      }}
    >
      <Rail>
        {({ getRailProps }) => (
          <div className="railStyle" {...getRailProps()} />
        )}
      </Rail>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className="slider-handles">
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
      <Tracks left={false} right={false}>
        {({ tracks, getTrackProps }) => (
          <div className="slider-tracks">
            {tracks.map(({ id, source, target }) => (
              <Track
                key={id}
                source={source}
                target={target}
                getTrackProps={getTrackProps}
              />
            ))}
          </div>
        )}
      </Tracks>
    </Slider>
  );
}
